const MAIN_STEP_1 = 'privacy-portal-theme-main-driver-step-1'
const MAIN_STEP_2 = 'privacy-portal-theme-main-driver-step-2'
const MAIN_STEP_3 = 'privacy-portal-theme-main-driver-step-3'

const IFRAME_STEP_1 = 'privacy-portal-theme-iframe-driver-step-1'
const IFRAME_STEP_2 = 'privacy-portal-theme-iframe-driver-step-2'

const MAIN_STEPS_OBJECT = [
  {
    element: '#' + MAIN_STEP_1,
    popover: {
      description:
        'Escolha as cores do seu Canal de Atendimento. É possível escolher até duas cores (primária, para cabecalho e rodapé; e secundária, para cards e botões). Você pode inserir o código da cor de acordo com as cores da sua empresa, ou escolher uma cor próxima pelo seletor.',
    },
  },
  {
    element: '#' + MAIN_STEP_2,
    popover: {
      description:
        'Pré-visualize as suas escolhas, para saber como elas aparecerão no Privacidade&Você.',
    },
  },
  {
    element: '#' + MAIN_STEP_3,
    popover: {
      description:
        'Clique em Salvar para aplicar as cores no seu portal de privacidade.',
    },
  },
]

const IFRAME_STEPS_OBJECT = [
  {
    element: '#' + MAIN_STEP_1,
    popover: {
      description:
        'A personalização de iframe permite incorporar o Portal de Privacidade diretamente no site da sua organização, sem que o usuário precise acessar outra página.',
    },
  },
  {
    element: '#' + IFRAME_STEP_1,
    popover: {
      description:
        'Personalize o portal nos botões abaixo. É possível pré-visualizar como ele ficará no site da sua organização.',
    },
  },
  {
    element: '#' + IFRAME_STEP_2,
    popover: {
      description:
        'Copie o código iframe gerado pela plataforma e encaminhe para o time de TI da sua organização, que irá incorporá-lo ao site.',
    },
  },
]

export default {
  MAIN_STEPS_OBJECT,
  MAIN_STEP_1,
  MAIN_STEP_2,
  MAIN_STEP_3,
  IFRAME_STEPS_OBJECT,
  IFRAME_STEP_1,
  IFRAME_STEP_2,
}
